// Define the valid values for each parameter
export type StageValues = "1" | "2" | "3";
export type ProductValues = "membershipOnly" | "nettle" | undefined;
export type ContractTypesByProduct = {
  nettle: "onceOff" | "monthly" | undefined;
  membershipOnly: "monthly" | "annual" | undefined;
};

export type ContractTypeValuesFor<P extends ProductValues> =
  P extends keyof ContractTypesByProduct ? ContractTypesByProduct[P] : never;

// Define the mapping of parameter names to their valid values
export type ValidURLParams<P extends ProductValues> = {
  stage: StageValues;
  product: P;
  contractType: ContractTypeValuesFor<P>;
};

export const STAGE_TITLES = {
  1: {
    stageTitle: "Select your solution",
  },
  2: {
    stageTitle: "Confirm purchase method",
  },
  3: {
    stageTitle: "Connect a Samphire account",
  },
} as const;

export const PRODUCT_TYPES = ["membershipOnly", "nettle", undefined] as const;

export const CONTRACT_TYPES = [
  "onceOff",
  "monthly",
  "annual",
  undefined,
] as const;

export const PRODUCT_OPTIONS: Record<
  Exclude<ProductTypes, undefined>,
  {
    name: string;
    description: string;
  }
> = {
  nettle: {
    name: "Nettle",
    description:
      "Nettle is a subscription that gives you access to all of our products.",
  },
  membershipOnly: {
    name: "Membership Only",
    description:
      "Membership Only is a subscription that gives you access to all of our products.",
  },
};

export type PrePurchaseStages = typeof STAGE_TITLES;
export type PrePurchaseStageKey = keyof PrePurchaseStages;
export type ProductTypes = (typeof PRODUCT_TYPES)[number];
